const deleteOrgMember = memberRef => {
  return memberRef
    .delete()
}

export default deleteOrgMember
